import { useState, useEffect } from 'react';
import { Loader2 } from 'lucide-react';

const DEFAULT_MESSAGES = [
  'Processing your request...',
  'This may take a few minutes...',
  'AI is working its magic...',
  'Almost there, hang tight...',
  'Generating your content...',
];

export function ProcessingAnimation({ messages = DEFAULT_MESSAGES, title = 'Processing...', subtitle, className = '' }) {
  const [msgIdx, setMsgIdx] = useState(0);
  const [dots, setDots] = useState('');

  useEffect(() => {
    const msgTimer = setInterval(() => setMsgIdx(i => (i + 1) % messages.length), 3500);
    const dotTimer = setInterval(() => setDots(d => d.length >= 3 ? '' : d + '.'), 500);
    return () => { clearInterval(msgTimer); clearInterval(dotTimer); };
  }, [messages.length]);

  return (
    <div className={`text-center py-10 ${className}`} data-testid="processing-animation">
      {/* Animated rings */}
      <div className="relative w-20 h-20 mx-auto mb-5">
        <div className="absolute inset-0 rounded-full border-[3px] border-emerald-100 animate-ping" style={{ animationDuration: '2s' }} />
        <div className="absolute inset-1 rounded-full border-[3px] border-emerald-200 animate-ping" style={{ animationDuration: '2.5s', animationDelay: '0.3s' }} />
        <div className="absolute inset-0 flex items-center justify-center">
          <Loader2 className="h-8 w-8 text-emerald-500 animate-spin" />
        </div>
      </div>
      <p className="text-sm font-semibold text-zinc-800">{title}{dots}</p>
      <p className="text-xs text-zinc-500 mt-1.5 transition-opacity duration-500">{messages[msgIdx]}</p>
      {subtitle && <p className="text-[10px] text-zinc-400 mt-2">{subtitle}</p>}
      {/* Animated progress bar */}
      <div className="w-48 mx-auto mt-4 h-1 bg-zinc-100 rounded-full overflow-hidden">
        <div className="h-full bg-gradient-to-r from-emerald-400 to-teal-400 rounded-full animate-indeterminate" />
      </div>
      <style>{`
        @keyframes indeterminate {
          0% { width: 0%; margin-left: 0%; }
          50% { width: 60%; margin-left: 20%; }
          100% { width: 0%; margin-left: 100%; }
        }
        .animate-indeterminate {
          animation: indeterminate 1.8s ease-in-out infinite;
        }
      `}</style>
    </div>
  );
}
